import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import api from '../../../utils/api';
import { User } from '../../../models/User';
import { AddUserForm } from './AddUserForm';
import {Modal} from '../../Modal';
import {ActionButton} from '../common/AdminButtons';
import {Table,Tr,Td,Th} from '../common/AdminTable';
import { ErrorMessage,LoadingMessage } from '../common/AdminMessages';
// Styled Components


const ListContainer = styled.div`
  padding: 20px;
`;

// Interfaces
interface UserRowProps {
  user: User;
}

interface UserListState {
  users: User[];
  loading: boolean;
  error: string | null;
  isModalOpen: boolean;
}

// Sub-Components
const TableHeader: React.FC = () => {
  return (
    <thead>
      <tr>
        <Th>Name</Th>
        <Th>Email</Th>
        <Th>Role</Th>
      </tr>
    </thead>
  );
};

const UserRow: React.FC<UserRowProps> = ({ user }) => {
  return (
    <Tr>
      <Td>{user.name}</Td>
      <Td>{user.email}</Td>
      <Td>{user.role}</Td>
    </Tr>
  );
};

// Main Component
const UserList: React.FC = () => {
  const [state, setState] = useState<UserListState>({
    users: [],
    loading: true,
    error: null,
    isModalOpen: false
  });

  const modalRef = useRef<HTMLDialogElement>(null);
  const fetchUsers = async () => {
    try {
      const response = await api.get<User[]>('/halo/users/');
      setState(prevState => ({
        ...prevState,
        users: response.data,
        loading: false,
        error: null
      }));
    } catch (err) {
      // Type assertion to access Axios error properties
      const axiosError = err as any;

      setState(prevState => ({
        ...prevState,
        loading: false,
        error: `Failed to fetch users: ${axiosError.message}${
          axiosError.response?.data ? ` - ${JSON.stringify(axiosError.response.data)}` : ''
        }`
      }));
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);


  //MODAL FUNCTIONS
  const closeModal = () =>{
    setState(prevState => ({
        ...prevState,
        isModalOpen: false
    })); 
  }
  const openModal = () =>{
    setState(prevState => ({
        ...prevState,
        isModalOpen: true
    })); 
  }
  const handleAddClick = () => {
    openModal();
  };
  const handleUserAdded = () => {
    fetchUsers();  // Refresh the user list after adding a new user
    closeModal();
  };
  
  const renderContent = () => {
    if (state.loading) {
      return <LoadingMessage>Loading users...</LoadingMessage>;
    }

    if (state.error) {
      return <ErrorMessage>{state.error}</ErrorMessage>;
    }

    return (
      <Table>
        <TableHeader />
        <tbody>
          {state.users.map((user) => (
            <UserRow key={user.id} user={user} />
          ))}
        </tbody>
      </Table>
    );
  };

  return (
    <ListContainer>
        <h1>Users</h1>
        <ActionButton onClick={handleAddClick}>Add User</ActionButton>
        <Modal isOpen={state.isModalOpen} onClose={closeModal}><AddUserForm onSuccess={handleUserAdded} onCancel={closeModal}></AddUserForm></Modal> 
      {renderContent()}
    </ListContainer>
  );
};

export default UserList;